import { UserOutlined } from "@ant-design/icons";
import { Grid, Layout, Menu, theme, Typography } from "antd";
import { TbMail, TbShieldLock } from "react-icons/tb";
import { useNavigate, useParams } from "react-router-dom";

import { ItemType, MenuItemType } from "antd/es/menu/interface";
import { FaSitemap } from "react-icons/fa";
import { FiBook, FiMessageCircle, FiSettings } from "react-icons/fi";
import { MdQuestionMark } from "react-icons/md";
import { AccountBox } from "../../components/settings/AccountBox";
import { AccountSettingsBox } from "../../components/settings/AccountSettingsBox";
import { IntegrationBox } from "../../components/settings/IntegrationsBox";
import { NotificationBox } from "../../components/settings/NotificationBox";
import { SettingsConversationalHistory } from "../../components/settings/SettingsConversationalHistory";

const { Sider, Content } = Layout;
const { useToken } = theme;
const { useBreakpoint } = Grid;

type ItemList = ItemType<MenuItemType> & { component: React.ReactNode };

export function Settings() {
  const { token } = useToken();
  const screens = useBreakpoint();
  const { pageId = "account" } = useParams();
  const navigate = useNavigate();

  const menuItemStyle: React.CSSProperties = {
    // lineHeight: token.lineHeight,
    // fontSize: token.fontSize,
    // color: token.colorIcon,
  };

  const items: ItemList[] = [
    {
      key: "account",
      icon: (
        <UserOutlined style={{ ...menuItemStyle, color: token.colorPrimary }} />
      ),
      label: <span style={menuItemStyle}>User Profile</span>,
      component: <AccountBox />,
    },
    {
      key: "account-settings",
      icon: (
        <FiSettings style={{ ...menuItemStyle, color: token.colorPrimary }} />
      ),
      label: <span style={menuItemStyle}>Account Settings </span>,
      component: <AccountSettingsBox />,
    },
    {
      key: "notification-and-alerts",
      icon: <TbMail style={{ ...menuItemStyle, color: token.colorPrimary }} />,
      label: <span style={menuItemStyle}>Notification and Alerts</span>,
      component: <NotificationBox />,
      disabled: true,
    },
    {
      key: "conversational",
      icon: (
        <FiMessageCircle
          style={{ ...menuItemStyle, color: token.colorPrimary }}
        />
      ),
      label: <span style={menuItemStyle}>Conversational History</span>,
      component: <SettingsConversationalHistory />,
    },
    {
      key: "integrations",
      icon: (
        <FaSitemap style={{ ...menuItemStyle, color: token.colorPrimary }} />
      ),
      label: <span style={menuItemStyle}>Integrations</span>,
      component: <IntegrationBox />,
    },
    {
      key: "privacy-and-policy",
      icon: (
        <TbShieldLock style={{ ...menuItemStyle, color: token.colorPrimary }} />
      ),
      label: <span style={menuItemStyle}>Privacy and Policy</span>,
      component: <IntegrationBox />,
      onClick: () => {
        window.open("https://zeitfy.com/privacy", "_blank");
      },
    },
    {
      key: "terms-of-use",
      icon: <FiBook style={{ ...menuItemStyle, color: token.colorPrimary }} />,
      label: <span style={menuItemStyle}>Terms of use</span>,
      component: <IntegrationBox />,
      onClick: () => {
        window.open("https://zeitfy.com/terms", "_blank");
      },
    },
    {
      key: "help-center",
      icon: (
        <MdQuestionMark
          style={{ ...menuItemStyle, color: token.colorPrimary }}
        />
      ),
      label: <span style={menuItemStyle}>Help center</span>,
      component: <IntegrationBox />,
      disabled: true,
    },
  ];

  const activeComponent =
    items.find((item) => item.key === pageId)?.component ?? items[0].component;

  return (
    <Layout
      style={{
        height: "100vh",
        width: "100%",
        paddingTop: token.paddingLG,
        paddingBottom: token.paddingLG,
        boxSizing: "border-box",
        backgroundColor: token.colorBgLayout,
      }}
    >
      <Sider
        style={{
          border: `1px solid ${token.colorBorderSecondary}`,
          display: screens.sm ? "flex" : "none",
          backdropFilter: "blur(20px)",
          flexDirection: "column",
          height: `calc(100% - ${token.paddingLG * 0}px)`,
          marginLeft: token.marginLG,
          backgroundColor: token.colorBgContainer,
          borderRadius: token.borderRadiusLG,
          overflow: "hidden",
        }}
        width={256}
        theme="light"
        trigger={null}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          <Typography.Title
            level={4}
            style={{
              fontWeight: token.fontWeightStrong,
              padding: token.paddingLG,
              marginBottom: 0,
              flexShrink: 0,
            }}
          >
            Settings
          </Typography.Title>
          <Menu
            theme="light"
            mode="inline"
            onClick={(event) => {
              navigate(`/settings/${event.key}`);
            }}
            style={{
              backgroundColor: "transparent",
              border: 0,
              flexGrow: 1,
              overflowY: "auto",
              overflowX: "hidden",
            }}
            selectedKeys={[`${pageId}`]}
            items={items}
          />
        </div>
      </Sider>

      <Layout
        style={{
          height: `calc(100% - ${token.paddingLG * 0}px)`,
          marginLeft: screens.sm ? token.marginLG : 0,
          marginRight: token.marginLG,
        }}
      >
        <Content
          style={{
            height: "100%",
            backgroundColor: token.colorBgContainer,
            borderRadius: token.borderRadiusLG,
            border: `1px solid ${token.colorBorderSecondary}`,
            overflowY: "auto",
            padding: token.paddingLG,
            boxSizing: "border-box",
          }}
        >
          {activeComponent}
        </Content>
      </Layout>
    </Layout>
  );
}
